import { useSyncExternalStore } from 'react';

import { getConfig, subscribeToConfig } from 'common/config';
import { CompanyConfig } from 'types';

/**
 * The `/api/config` payload as React state: `undefined` until the fetch
 * resolves, then the loaded config, re-rendering the caller when it lands.
 *
 * Below `AppConfigProvider` the `config` binding can be read directly. This is
 * for what mounts above it and would otherwise latch its first render's value.
 * The server render seeds an empty config and never fetches, so the same
 * snapshot serves both sides.
 */
export function useAppConfig(): CompanyConfig | undefined {
  return useSyncExternalStore(subscribeToConfig, getConfig, getConfig);
}
